var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      on: { dragover: _vm.dragover, dragleave: _vm.dragleave, drop: _vm.drop },
    },
    [
      _c("div", { staticClass: "upload-box-mini glow" }, [
        _c("form", [
          _c("input", {
            ref: "file",
            staticClass: "hidden-input",
            attrs: {
              type: "file",
              multiple: "",
              name: "file",
              id: "fileInput",
            },
            on: { change: _vm.onChange },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "upload-box-inner" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "font-weight-bold" }, [
            _c(
              "label",
              { staticClass: "file-label", attrs: { for: "fileInput" } },
              [
                _vm.isDragging
                  ? _c("div", [_vm._v("Release to drop files here.")])
                  : _c("div", { staticStyle: { color: "#ccc" } }, [
                      _vm._v("Drop files here or "),
                      _c("u", [_vm._v("click here")]),
                      _vm._v(" to upload."),
                    ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("i", {
        staticClass: "fa fa-cloud-upload-alt fa-5x vue-uploadbox-icon",
        attrs: { "data-v-006c151a": "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }